import {Component, OnInit} from '@angular/core';
import {LocalStorageService} from '../../services/local-storage.service';
import {OrdersView} from '../../enums/OrdersView';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-board-user',
  styleUrls: ['./board-user.component.scss'],
  templateUrl: './board-user.component.html',
})
export class BoardUserComponent implements OnInit {

  public currentUser: any;
  public OrdersView = OrdersView;
  public showAdminBoard: boolean;
  public isLoggedIn = false;
  private roles: string[];

  constructor(public languageService: LanguageService,
              private localStorageService: LocalStorageService) { }

  public ngOnInit(): void {
    this.currentUser = this.localStorageService.getUser();
    this.isLoggedIn = !!this.localStorageService.getToken();

    if (this.isLoggedIn) {
      this.roles = this.currentUser.roles;
      this.showAdminBoard = this.roles.includes('ROLE_ADMIN');
    }
  }
}
